import { createAction, props } from '@ngrx/store';
import { IAdultsInCharge } from 'src/app/core/models/infant-reassignment-control.model';

export const SetInfantReassignmentControl = createAction(
  '[Infant Control] Set SetInfantReassignmentControl',
  props<{ adultsInCharge: IAdultsInCharge; infantID: string }>()
);

export const ClearInfantReassignmentControl = createAction(
  '[Infant Control] Clear ClearInfantReassignmentControl',
  props<{ adultsInCharge: IAdultsInCharge; infantID: string }>()
);
